export default __webpack_public_path__ + "static/media/TWO_STATES.009f8088.jpg";